module.exports = __webpack_public_path__ + "img/responsive hospitium-01.4dcd48fa.jpg";